module.exports = __webpack_public_path__ + "media/images/normal_logo_symbol-ca3f5d1cdf32e411985623b69464f032.svg";